import React, { useEffect, useState } from 'react';

import {
    Container,
    Row,
    Col,
    Card,
    CardBody,
    Button,
    FormFeedback,
    Modal,
    ModalHeader,
    ModalBody,
    ModalFooter,
    Form,
    FormGroup,
    Label,
    Input,
    Alert,
} from "reactstrap";
import Swal from "sweetalert2";
// Formik validation
import * as Yup from "yup";
import { useFormik } from "formik";
//redux
import { useSelector, useDispatch } from "react-redux";
import { createSelector } from "reselect";
import { Link, useNavigate } from "react-router-dom";
import PasswordField from 'components/Common/PasswordInput';
import { userForgetPassword, changePasswordAction } from "../../store/actions";


const ChangePassword = ({ visible, toggle }) => {
    const dispatch = useDispatch();

    const navigate = useNavigate();

    const [showPassword, setShowPassword] = useState(false);

    const togglePasswordVisibility = () => {
        setShowPassword(!showPassword);
    };

    // Backend password policy: min 8 with lower/upper/digit/special.
    const PASSWORD_REGEX = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&]).{8,}$/;

    const validation = useFormik({
        // enableReinitialize : use this  flag when initial values needs to be changed
        enableReinitialize: true,

        initialValues: {
            current: '',
            confirm: '',
            password: '',
        },
        validationSchema: Yup.object({
            current: Yup.string().required("Please Enter Your Current Password"),
            password: Yup.string()
                .required("Please Enter Your Password")
                .matches(PASSWORD_REGEX, "Password does not meet the requirements below."),
            confirm: Yup.string()
                .required("Please Enter Password Confirmation")
                .oneOf([Yup.ref("password")], "Your password and confirmation password do not match."),
        }),
        onSubmit: (values) => {
            const { current, confirm, password } = values;
            if (confirm === password) {
                dispatch(changePasswordAction({
                    currentPassword: current,
                    newPassword: password,
                    confirmPassword: confirm,
                }));
            }
            else {
                validation.setFieldError(
                    'confirm',
                    'Your password and confirmation password do not match.'
                );
            }
        }
    });

    const ProfileProperties = createSelector(
        (state) => state.Profile,
        (profile) => ({
            changePasswordError: profile.changePasswordErrorMsg,
            changePasswordSuccess: profile.changePasswordSuccess,

        })
    );

    const {
        changePasswordError,
        changePasswordSuccess,
    } = useSelector(ProfileProperties);

    // changePasswordError may be a server message string or a raw error object.
    const changePasswordErrorMessage = changePasswordError
        ? typeof changePasswordError === "string"
            ? changePasswordError
            : changePasswordError?.response?.data?.message ||
              "Could not change password. Please check your current password and try again."
        : null;

    // Live new-password requirement checklist.
    const pw = validation.values.password || "";
    const passwordRules = [
        { label: "At least 8 characters", ok: pw.length >= 8 },
        { label: "An uppercase letter (A–Z)", ok: /[A-Z]/.test(pw) },
        { label: "A lowercase letter (a–z)", ok: /[a-z]/.test(pw) },
        { label: "A number (0–9)", ok: /\d/.test(pw) },
        { label: "A special character (@ $ ! % * ? &)", ok: /[@$!%*?&]/.test(pw) },
    ];

    useEffect(() => {
        if (changePasswordSuccess) {
            Swal.fire("Success", "Password changed successfully!", "success");
            toggle();
        }
    }, [changePasswordSuccess]);

    return (
        <Modal isOpen={visible} toggle={toggle} centered>
            <ModalHeader toggle={toggle}>Change Password</ModalHeader>
            <Form onSubmit={(e) => {
                e.preventDefault();
                validation.handleSubmit();
                return false;
            }}>
                <ModalBody>
                    {changePasswordErrorMessage && (
                        <Alert color="danger">{changePasswordErrorMessage}</Alert>
                    )}
                    <PasswordField validation={validation} name={'current'} label={'Current Password'} placeholder={'Enter current password'} />
                    <PasswordField validation={validation} name={'password'} label={'New Password'} placeholder={'Enter new password'} />
                    {pw.length > 0 && (
                        <ul className="list-unstyled mb-3 mt-1 ms-1">
                            {passwordRules.map((rule) => (
                                <li
                                    key={rule.label}
                                    className={rule.ok ? "text-success" : "text-muted"}
                                    style={{ fontSize: "0.85rem" }}
                                >
                                    <i className={`mdi ${rule.ok ? "mdi-check-circle" : "mdi-circle-outline"} me-1`} />
                                    {rule.label}
                                </li>
                            ))}
                        </ul>
                    )}
                    <PasswordField validation={validation} name={'confirm'} label={'Password Confirmation'} placeholder={'Confirm password'} />
                </ModalBody>
                <ModalFooter>
                    <Button color="secondary" onClick={toggle}>
                        Cancel
                    </Button>
                    <Button color="primary" type="submit">
                        Change Password
                    </Button>
                </ModalFooter>
            </Form>
        </Modal>
    )
}

export default ChangePassword;
